



































































import Vue from 'vue';
import BbTools from '@/tools/bluebird';
import LearningTools from '@/tools/learning';
import ProCard from '@/components/ui/ProCard.vue';
import DetectRTC from 'detectrtc';

export default Vue.extend({
  props: ['cameraActivity'],
  components: {
    'pro-card': ProCard,
  },
  data() {
    return {
      deviceError: '',
      deviceErrorExplanation: '',
      loading: false,
    };
  },
  mounted() {
    this.getDevicesInfo();
  },
  methods: {
    onSkip() {
      this.$emit('nextStep');
    },
    async onTry() {
      if (!this.loading) {
        this.loading = true;
        await BbTools.sleepCancelable(1200, this.$store);
        this.getDevicesInfo();
      }
    },
    getDevicesInfo() {
      const drtc: any = DetectRTC;
      drtc.load(() => {
        if (drtc.isWebRTCSupported) {
          if (this.cameraActivity) {
            LearningTools.captureDevice(navigator, { video: true, audio: true },
              this.deviceSuccessCallback, this.deviceErrorCallback);
          } else {
            LearningTools.captureDevice(navigator, { video: false, audio: true },
              this.deviceSuccessCallback, this.deviceErrorCallback);
          }
        } else {
          if (this.cameraActivity) {
            this.deviceError = this.$store.state.tr.CamNoWebRTC;
            this.deviceErrorExplanation = this.$store.state.tr.CamNoWebRTCExplanation;
          } else {
            this.deviceError = this.$store.state.tr.MicNoWebRTC;
            this.deviceErrorExplanation = this.$store.state.tr.MicNoWebRTCExplanation;
          }
          this.loading = false;
        }
      });
    },
    deviceSuccessCallback() {
      this.$emit('deviceEnabled');
    },
    deviceErrorCallback() {
      this.loading = false;
      if (this.cameraActivity) {
        this.deviceError = this.$store.state.tr.CamNoAccess;
        this.deviceErrorExplanation = this.$store.state.tr.CamNoAccessExplanation;
      } else {
        this.deviceError = this.$store.state.tr.MicNoAccess;
        this.deviceErrorExplanation = this.$store.state.tr.MicNoAccessExplanation;
      }
    },
  },
});
